import Root from './Root';

export default Root;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/Root/index.ts